// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Lock(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Lock" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 10H4V22H20V10H18V8C18 4.68629 15.3137 2 12 2C8.68629 2 6 4.68629 6 8V10ZM15 10V8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8V10H15ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Lock.js.map